export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtPpdruh';
export const NAME = 'PpDruh';
